export default __webpack_public_path__ + "static/media/loading_whitebackground.aad01c44.gif";